<form [formGroup]="form" class="space-y-8">
  <section class="space-y-4">
    <h1 class="section-heading">
      {{ "VENUE.FORM.EVENT_INFROMATION" | translate }}
    </h1>
    <div class="fields-container">
      <!-- <div class="field-control">
        <app-boolean
          [label]="'VENUE.FORM.WHO_ORG' | translate"
          [options]="[
            { label: 'VENUE.FORM.MYSELF' | translate, value: 'self' },
            { label: 'VENUE.FORM.SOMEONE' | translate, value: 'other' }
          ]"
          [control]="form.get('organiserType')!"
        />
      </div> -->
      <div class="field-control">
        <app-text-field
          [label]="'VENUE.FORM.ORG_NAME' | translate"
          [control]="form.get('organiserName')!"
        >
        </app-text-field>
      </div>
      <div class="field-control">
        <app-text-field
          [label]="'VENUE.FORM.ORG_NAME_AR' | translate"
          [control]="form.get('organiserNameAr')!"
        >
        </app-text-field>
      </div>
      <div class="field-control">
        <app-text-field
          [label]="'VENUE.FORM.EMAIL' | translate"
          [control]="form.get('email')!"
        >
        </app-text-field>
      </div>
      <div class="field-control">
        <!-- <app-text-field
          [label]="'VENUE.FORM.MOBILE_NUMBER' | translate"
          [control]="form.get('mobileNumber')!"
        >
        </app-text-field> -->
        <app-mobile-number
          [control]="form.get('mobileNumber')"
          [countryCodeControl]="form.get('mobileCountryCode')"
          [label]="'VENUE.FORM.MOBILE_NUMBER' | translate"
          [validationMessages]="{
            mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
            uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate,
          }"
        />
      </div>
      <div class="field-control">
        <app-text-field
          [label]="'VENUE.FORM.EVENT_TITLE' | translate"
          [control]="form.get('eventTitle')!"
        >
        </app-text-field>
      </div>
      <div class="field-control">
        <app-option-field
          [label]="'VENUE.FORM.EVENT_TYPE' | translate"
          [options]="eventTypeOptions"
          [control]="form.get('eventType')!"
          [labelKey]="'label'"
          [valueKey]="'value'"
          [loading]="masterDataLoading"
        >
        </app-option-field>
      </div>
      <div class="field-control">
        <app-option-field
          [label]="'VENUE.FORM.ROOM_SETUP' | translate"
          [options]="roomSetupOptions"
          [control]="form.get('roomSetup')!"
          [labelKey]="'label'"
          [valueKey]="'value'"
          [loading]="masterDataLoading"
        >
        </app-option-field>
      </div>
      @if (showCateringFields) {
        <div class="field-control">
          <app-option-field
            [label]="'VENUE.FORM.CATERING_OPTION' | translate"
            [options]="cateringOptionOptions"
            [control]="form.get('cateringOption')!"
            [labelKey]="'label'"
            [valueKey]="'value'"
            [loading]="masterDataLoading"
          >
          </app-option-field>
        </div>
        <div class="field-control">
          <app-option-field
            [label]="'VENUE.FORM.CATERING_TYPE' | translate"
            [options]="cateringTypeOptions"
            [control]="form.get('cateringType')!"
            [labelKey]="'label'"
            [valueKey]="'value'"
            [loading]="masterDataLoading"
            [isMultiple]="true"
          >
          </app-option-field>
        </div>
      }

      <div class="field-control">
        <app-option-field
          [label]="'VENUE.FORM.SELECT_REMINDER' | translate"
          [options]="reminderOptions"
          [control]="form.get('reminder')!"
          [labelKey]="'label'"
          [valueKey]="'value'"
          [loading]="masterDataLoading"
        >
        </app-option-field>
      </div>

      <div class="field-control">
        <app-text-field
          type="big-text"
          [label]="'VENUE.FORM.INFO' | translate"
          [control]="form.get('eventInfo')!"
          [maxlength]="10000"
        >
        </app-text-field>
      </div>
      <div class="field-control">
        <app-text-field
          [type]="'number'"
          [label]="'VENUE.FORM.NUMBER_OF_ATTENDEES' | translate"
          [control]="form.get('attendeeCount')!"
          [maxlength]="10"
        >
        </app-text-field>
        <!-- @if (form.get('attendeeCount')?.touched && form.get('attendeeCount')?.errors?.['maxSeats']) {
          <div class="fields-error-container">
            Number of attendees cannot be more than {{ noOfSeats }}.
          </div>
        } -->
      </div>

      <div class="field-control">
        <label class="field-label">
          {{ "VENUE.FORM.ADD_GUEST" | translate }}
        </label>
        <div
          class="flex items-stretch overflow-hidden border border-dc-navy/30 bg-white focus-within:border-dc-navy focus-within:ring-2 focus-within:ring-dc-navy/20"
        >
          <input
            type="text"
            formControlName="guestEmail"
            [placeholder]="'VENUE.FORM.ADD_GUEST_PLACEHOLDER' | translate"
            class="form-input w-full px-3 py-3 text-dc-navy transition border focus:outline-none disabled:cursor-not-allowed disabled:bg-[#eeeeee]"
            (keydown)="onGuestInputKeydown($event)"
          />
          @if (actionsEnabled) {
            <button
              type="button"
              class="shrink-0 border-s border-dc-navy/20 bg-dc-navy px-4 text-xs font-semibold text-white transition hover:bg-[#053456]"
              (click)="addGuest()"
            >
              <i class="fas fa-plus"></i>
            </button>
          }
        </div>

        @if (
          this.form.get("guestEmail")?.touched &&
          this.form.get("guestEmail")?.invalid
        ) {
          <div class="fields-error-container">
            {{ "VALIDATION_MSG.VALID_EMAIL" | translate }}
          </div>
        }
        @if (guestInputError) {
          <div class="fields-error-container">
            {{ guestInputError }}
          </div>
        }

        @if (guestEmails.length) {
          <div class="mt-3 flex flex-wrap gap-2">
            @for (guest of guestEmails; track guest; let i = $index) {
              <span
                class="inline-flex items-center gap-2 border border-dc-navy bg-[#f4f8fb] px-3 py-1.5 text-sm text-dc-navy"
              >
                <span>{{ guest }}</span>
                @if (actionsEnabled) {
                  <button
                    type="button"
                    class="text-dc-navy/70 transition hover:text-red-600"
                    (click)="removeGuest(i)"
                    [attr.aria-label]="'Remove guest ' + guest"
                  >
                    <i class="fas fa-times text-xs"></i>
                  </button>
                }
              </span>
            }
          </div>
        }
      </div>
      <div class="field-control">
        <app-boolean
          [label]="'VENUE.FORM.PARKING' | translate"
          [options]="[
            {
              label: 'VENUE.FORM.PARKING_Yes' | translate,
              value: 'Yes',
            },
            {
              label: 'VENUE.FORM.PARKING_No' | translate,
              value: 'No',
            },
          ]"
          [control]="form.get('needParking')!"
        />
      </div>
      @if (isNeedParkingSelected()) {
        <div class="field-control">
          <app-text-field
            [type]="'number'"
            [label]="'VENUE.FORM.PARKING_SLOTS' | translate"
            [control]="form.get('parkingSlots')!"
            [maxlength]="10"
          >
          </app-text-field>
        </div>
      }
    </div>
    <section>
      <h1 class="section-heading">
        {{ "VENUE.FORM.BANK_DETAILS_TITLE" | translate }}
      </h1>
      <div class="fields-container">
        <div class="field-control">
          <app-text-field
            [label]="'VENUE.FORM.ACCOUNT_HOLDER_NAME' | translate"
            [control]="form.get('accountHolderName')!"
          >
          </app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            [label]="'VENUE.FORM.IBAN_NUMBER' | translate"
            [control]="form.get('ibanNumber')!"
            [maxlength]="23"
          >
          </app-text-field>
        </div>
      </div>
    </section>

    <section class="pt-2">
      <h1 class="section-heading">
        {{ "VENUE.FORM.UPLOAD_DOCUMENTS_TITLE" | translate }}
      </h1>
      <div class="fields-container">
        @for (dt of tradeLicenseDocumentTypes; track $index) {
          <div class="field-control">
            <app-file
              #fileCmp
              [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
              [documentType]="dt.nameEn"
              (folderMissing)="folderMissing.emit()"
              (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
              [showAction]="actionsEnabled"
              [folder]="srFolder"
              [documentServiceType]="documentServiceType.VENB"
            ></app-file>
          </div>
        }
      </div>
    </section>

    <!-- Request more info -->
    @if (
      showRequestedMoreInfoSection ||
      (form.get("requestedInfoByCustomer")?.value &&
        form.get("requestedInfoByAdmin")?.value)
    ) {
      <section>
        <h1 class="section-heading">
          {{ "VENUE.FORM.REQUESTED_MORE_INFO" | translate }}
        </h1>
        <div class="fields-container">
          <div class="field-control">
            <app-text-field
              [type]="'big-text'"
              [label]="'VENUE.FORM.REQUESTED_INFO_BY_ADMIN' | translate"
              [control]="form.get('requestedInfoByAdmin')!"
            >
            </app-text-field>
          </div>
          <div class="field-control">
            <app-text-field
              [type]="'big-text'"
              [label]="'VENUE.FORM.REQUESTED_INFO_BY_CUSTOMER' | translate"
              [control]="form.get('requestedInfoByCustomer')!"
            >
            </app-text-field>
          </div>
        </div>
      </section>
    }

    <!-- NOC Certificate Status -->
    @if (isNocCertificateApproved || isPendingApproval || isVenueBooked) {
      <section>
        <h1 class="section-heading">
          {{ "VENUE.FORM.NOC_CERTIFICATE_STATUS" | translate }}
        </h1>
        <div class="fields-container mt-6">
          <span
            class="inline-block bg-[#cde7d6] text-[#20854b] text-sm px-3 py-1"
          >
            {{ "VENUE.FORM.NOC_STATUS_APPROVED" | translate }}
          </span>

          <hr class="my-8 border-gray-300" />

          <p class="text-sm mb-6">
            {{ "VENUE.FORM.NOC_APPROVED_MESSAGE" | translate }}
          </p>

          <div
            class="flex flex-wrap gap-3 justify-start ltr:text-left rtl:text-right"
          >
            <app-button
              [type]="'button'"
              [label]="'VENUE.FORM.VIEW_DETAILS' | translate"
              classesName="card-edge-cut-white"
              (onBtnClick)="onViewNocCertificate()"
            />
            <app-button
              [type]="'button'"
              [label]="'VENUE.FORM.DOWNLOAD' | translate"
              classesName="card-edge-cut-white"
              (onBtnClick)="onDownloadNocCertificate()"
            />
          </div>

          <hr class="my-8 border-gray-300" />
        </div>
      </section>
    }

    @if (isNocCertificateApproved || isPendingApproval || isVenueBooked) {
      <section class="space-y-4">
        <h1 class="section-heading">
          {{ "VENUE.FORM.UPLOAD_OTHER_APPROVAL_DOCUMENTS" | translate }}
        </h1>
        <div class="fields-container">
          @for (dt of otherApprovalDocumentTypes; track $index) {
            <div class="field-control">
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [documentType]="dt.nameEn"
                (folderMissing)="folderMissing.emit()"
                (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                [showAction]="allowOtherApprovalActions"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.VENB"
              ></app-file>
            </div>
          }
        </div>
      </section>
    }

    @if (
      isRejected &&
      (form.get("rejectionReason")?.value ||
        form.get("reasonForCancellation")?.value)
    ) {
      <section>
        <div class="fields-container">
          @if (form.get("rejectionReason")?.value) {
            <div class="field-control">
              <app-text-field
                [type]="'big-text'"
                [label]="'VENUE.FORM.REJECTION_REASON' | translate"
                [control]="form.get('rejectionReason')!"
              >
              </app-text-field>
            </div>
          }
          @if (form.get("reasonForCancellation")?.value) {
            <div class="field-control">
              <app-text-field
                [type]="'big-text'"
                [label]="'VENUE.FORM.REJECTION_REASON' | translate"
                [control]="form.get('reasonForCancellation')!"
              >
              </app-text-field>
            </div>
          }
        </div>
      </section>
    }

    <section class="space-y-4">
      <div class="fields-container">
        <div class="field-control col-span-full">
          <div class="flex items-start gap-5 lg:gap-x-2 relative">
            <input
              formControlName="confirmInformation"
              type="checkbox"
              [disabled]="!actionsEnabled || isNocCertificateApproved"
              class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
              (click)="onConfirmInformationClick($event)"
            />
            <span
              class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy"
            >
              <i class="fas fa-check"></i>
            </span>
            <span class="pt-0.5 text-sm text-dc-navy">
              {{ "VENUE.FORM.CONFIRM_INFORMATION_PREFIX" | translate }}
              <button
                type="button"
                class="font-semibold text-dc-navy underline underline-offset-2"
                (click)="openTermsModal()"
              >
                {{ "VENUE.FORM.TERMS_AND_CONDITIONS_LINK" | translate }}
              </button>
              {{ "VENUE.FORM.CONFIRM_INFORMATION_SUFFIX" | translate }}
            </span>
          </div>
          @if (
            form.get("confirmInformation")?.touched &&
            form.get("confirmInformation")?.invalid
          ) {
            <div class="fields-error-container">
              {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
            </div>
          }
        </div>

        <!-- Error Message -->
        @if (technicalErrorMsg) {
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
            }"
            [showbutton]="false"
          ></app-validation-message>
        }

        <div class="field-control col-span-full flex flex-col gap-4">
          @if (canSubmit && !submitting) {
            <app-button
              type="button"
              [label]="submitButtonLabel | translate"
              classesName="btn-edge-cut btn-width-auto"
              [disabled]="submitting"
              (onBtnClick)="submit()"
            >
            </app-button>

            @if (canShowCancelBookingButton) {
              <app-button
                type="button"
                [label]="'VENUE.FORM.CANCEL_BOOKING' | translate"
                classesName="card-edge-cut-white btn-width-auto"
                [disabled]="submitting"
                (onBtnClick)="cancelBooking()"
              >
              </app-button>
            }
          }
          @if (submitting) {
            <app-button
              type="button"
              classesName="btn-edge-cut btn-width-auto"
              [label]="'PLEASE_WAIT' | translate"
              [disabled]="true"
            ></app-button>
          }
        </div>
      </div>
    </section>
  </section>
</form>

@if (showCancelBookingModal) {
  <div class="dc-modal">
    <div class="dc-modal-container bg-white min-w-3xs! max-w-[450px]!">
      <div class="text-left">
        <h2 class="text-2xl font-semibold text-dc-navy">
          {{ "VENUE.FORM.CANCEL_BOOKING" | translate }}
        </h2>
        <form [formGroup]="cancelBookingForm" class="space-y-6 pt-8">
          <app-option-field
            [label]="'VENUE.FORM.CANCELLATION_REASON' | translate"
            [options]="cancellationOptions"
            [control]="cancelBookingForm.get('cancellationReason')!"
            [labelKey]="'label'"
            [valueKey]="'value'"
            [loading]="masterDataLoading"
          >
          </app-option-field>
        </form>
      </div>
      <div class="flex gap-3 justify-center mt-8">
        <app-button
          type="button"
          classesName="card-edge-cut-white"
          [label]="'BUTTONS.SUBMIT' | translate"
          (onBtnClick)="submitCancelBooking()"
        ></app-button>
        <app-button
          type="button"
          classesName="btn-edge-cut"
          [label]="'BUTTONS.CLOSE' | translate"
          (onBtnClick)="closeCancelBookingModal()"
        ></app-button>
      </div>
    </div>
  </div>
}

@if (showTermsModal) {
  <div class="dc-modal">
    <div class="dc-modal-container !max-h-[60vh] overflow-y-auto">
      <div class="flex items-start justify-between gap-4 border-b border-gray-200 pb-2">
        <h2 class="text-2xl font-semibold text-dc-navy">
          {{ "VENUE.FORM.TERMS_AND_CONDITIONS_TITLE" | translate }}
        </h2>
       
      </div>
      <div class="leading-7 text-dc-navy pe-3 mt-2">
        @for (paragraph of termsAndConditionsContent.intro || []; track $index) {
          <p class="text-dc-navy! text-sm! text-justify!">
            {{ paragraph }}
          </p>
        }

        @for (section of termsAndConditionsContent.sections || []; track $index) {
          <div class="mb-8">
            <h3 class="mb-4 text-xl font-semibold text-dc-navy">
              {{ section.title }}
            </h3>

            @if (section.items?.length) {
              <ol class="list-decimal ps-6 space-y-4">
                @for (item of section.items || []; track $index) {
                  <li class="ps-2 text-justify text-sm!">
                    {{ item }}
                  </li>
                }
              </ol>
            }

            @if (section.bulletItems?.length) {
              <ul class="list-disc ps-8 mt-4 space-y-3">
                @for (bullet of section.bulletItems || []; track $index) {
                  <li class="ps-2 text-justify text-sm!">
                    {{ bullet }}
                  </li>
                }
              </ul>
            }

            @for (paragraph of section.footer || []; track $index) {
              <p class="mt-4 text-justify text-sm! text-dc-navy!">
                {{ paragraph }}
              </p>
            }
          </div>
        }
      </div>
      <div class="mt-8 flex gap-3 justify-end">
        <app-button
          type="button"
          classesName="card-edge-cut-white"
          [label]="'BUTTONS.CANCEL' | translate"
          (onBtnClick)="closeTermsModal()"
        ></app-button>
        <app-button
          type="button"
          classesName="btn-edge-cut"
          [label]="'VENUE.CONFIRM' | translate"
          (onBtnClick)="confirmTermsAndConditions()"
        ></app-button>
      </div>
    </div>
  </div>
}
